document.addEventListener("DOMContentLoaded", function () {
  /* CSS classes */
  const htmlPopupOpen = "m-calc-popup-open";
  const popupShow = "show";
    
  const button = document.getElementById("sizes-chart-button");
  const popup = document.getElementById("sizes-chart-popup");
  const closePopup = document.getElementById("sizes-chart-close");

  const htmlElement = document.documentElement;

  button.addEventListener("click", function () {
    popup.classList.add(popupShow);
    htmlElement.classList.add(htmlPopupOpen);
  });

  closePopup.addEventListener("click", function () {
    popup.classList.remove(popupShow);
    htmlElement.classList.remove(htmlPopupOpen);
  });

  window.addEventListener("click", function (event) {
    if (event.target == popup) {
      popup.classList.remove(popupShow);
      htmlElement.classList.remove(htmlPopupOpen);
    }
  });

  function getProductType() {
    const productTypeElement = document.querySelector(".product-page-section");
    return productTypeElement ? productTypeElement.dataset.productType : "";
  }
});
